// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  AddTaskOutlined,
  Contrast,
  PendingOutlined,
  SuccessStatusIcon,
} from '@/constants/hardfin-standard-icons';
import { FulfillmentBySkuReportStatus } from '@/report/api/types';
import { SvgIconProps } from '@mui/material';

interface Props extends Pick<SvgIconProps, 'fontSize'> {
  status: FulfillmentBySkuReportStatus;
}

export function FulfillmentBySkuReportStatusIcon(props: Props) {
  switch (props.status) {
    case 'OPEN':
      return <PendingOutlined fontSize={props.fontSize} />;
    case 'PARTIALLY_FULFILLED':
      return <Contrast fontSize={props.fontSize} />;
    case 'FULLY_FULFILLED':
      return <SuccessStatusIcon fontSize={props.fontSize} />;
    case 'OVERAGE':
      return <AddTaskOutlined fontSize={props.fontSize} />;
  }
}
